<template>
  <div class="image">
  
  </div>
  <h4>Guide</h4>
  <div class="guide">
  </div>
  
  <h4>Scanner un varibox</h4>
  <div class="scanner">
  </div>
  
  </template>

<script setup>
</script>
    
  <style scoped>
  .image{
    background-color: red;
    width: 80vw;
    margin: 0 auto;
    height: 80px;
  }
  
  .guide{
    background-color: blue;
    width: 90vw;
    margin: 0 auto;
    height: 80px;
  }
  
  .scanner{
    background-color: yellow;
    width: 90vw;
    margin: 0 auto;
    height: 80px;
  }
  </style>